module.exports = __webpack_public_path__ + "img/TRC.8a3cdaad.png";